<template>
  <div class="page_socialInsurance">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>社保</el-breadcrumb-item>
          <el-breadcrumb-item>缴费标准</el-breadcrumb-item>
          <el-breadcrumb-item>{{ handleType=='add' ? '手工新增' : handleType=='edit' ? '编辑' : '明细' }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs" v-loading="loading">

        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="社保" name="社保"></el-tab-pane>
          <el-tab-pane label="公积金" name="公积金"></el-tab-pane>
        </el-tabs>
        <div class="flex aic">
          <div class="r_edit_title">
            <div class="line_box"></div>
            {{activeName}}基本信息
          </div>
        </div>
        <el-form :model="addForm" :inline="true" ref="addForm" :rules="rules" label-width="120px" size="small" :disabled="handleType != 'edit' && handleType != 'add'">
          <template v-if="activeName == '社保'">
            <el-form-item label="参保账户:" prop="socialSettingsId">
              <el-select v-model="addForm.socialSettingsId" placeholder="" clearable size="small" style="width: 300px;" filterable @change="changeAcconut">
                <el-option v-for="(item,index) in accountList" :key="index" :label="item.accountFullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="供应商全称:">
              <el-input v-model="addForm.supplier" size="small" disabled readonly style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="地区:">
              <el-input v-model="addForm.area" size="small" disabled readonly style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="年度基数调整月:">
              <el-select v-model="addForm.adjustmentMonth" placeholder="" clearable size="small" style="width: 300px;" filterable>
                <el-option v-for="(item,index) in 12" :key="index" :value="item + '月'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="增员截止日期:">
              <el-select v-model="addForm.memberStartMonth" placeholder="" clearable size="small" style="width: 300px;" filterable>
                <el-option v-for="(item,index) in 31" :key="index" :value="'当月' + item + '号'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="减员截止日期:">
              <el-select v-model="addForm.memberEndMonth" placeholder="" clearable size="small" style="width: 300px;" filterable>
                <el-option v-for="(item,index) in 31" :key="index" :value="'当月' + item + '号'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="增员月差:">
              <el-select v-model="addForm.startMonthdDiff" placeholder="" clearable size="small" style="width: 300px;" filterable>
                <el-option value="当月增当月"></el-option>
                <el-option value="当月增次月"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="减员月差:">
              <el-select v-model="addForm.endMonthdDiff" placeholder="" clearable size="small" style="width: 300px;" filterable>
                <el-option value="当月减当月，当月不产生费用"></el-option>
                <el-option value="当月减次月，次月不产生费用"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生效时间:" prop="effectiveTime">
              <el-date-picker v-model="addForm.effectiveTime" type="date" value-format="yyyy-MM-dd" placeholder="" size="small" style="width:300px"></el-date-picker>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="addForm.notes" size="small" clearable style="width:300px"></el-input>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="年度基数调整月:">
              <el-select v-model="addForm.fundAdjustmentMonth" placeholder="" clearable size="small" style="width: 300px;" filterable>
                <el-option v-for="(item,index) in 12" :key="index" :value="item + '月'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="增员截止日期:">
              <el-select v-model="addForm.fundMemberStartMonth" placeholder="" clearable size="small" style="width: 300px;" filterable>
                <el-option v-for="(item,index) in 31" :key="index" :value="'当月' + item + '号'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="减员截止日期:">
              <el-select v-model="addForm.fundMemberEndMonth" placeholder="" clearable size="small" style="width: 300px;" filterable>
                <el-option v-for="(item,index) in 31" :key="index" :value="'当月' + item + '号'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="增员月差:">
              <el-select v-model="addForm.fundStartMonthdDiff" placeholder="" clearable size="small" style="width: 300px;" filterable>
                <el-option value="当月增当月"></el-option>
                <el-option value="当月增下月"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="减员月差:">
              <el-select v-model="addForm.fundEndMonthdDiff" placeholder="" clearable size="small" style="width: 300px;" filterable>
                <el-option value="当月减当月"></el-option>
                <el-option value="当月减下月"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生效时间:">
              <el-date-picker v-model="addForm.fundEffectiveTime" type="date" value-format="yyyy-MM-dd" placeholder="" size="small" style="width:300px"></el-date-picker>
            </el-form-item>
            <el-form-item label="公积金备注">
              <el-input v-model="addForm.fundNotes" size="small" clearable style="width:300px"></el-input>
            </el-form-item>
          </template>
        </el-form>

        <div class="flex aic">
          <div class="r_edit_title">
            <div class="line_box"></div>
            明细
          </div>
        </div>
        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="addItem" v-if="handleType == 'edit' || handleType == 'add'">添加险种+</el-button>
          <el-button type="primary" size="small" @click="expDtl" :loading="isExping2" v-if="handleType == 'dtl'">明细导出</el-button>
        </div>
        <el-table :data="addForm.detailDtos" border class="doc_table" max-height="500px" show-summary :summary-method="getSummaries" style="width:100%">
          <el-table-column key="1" label="序号" min-width="50" align="center" fixed="left">
            <template slot-scope={$index}>{{$index + 1}}</template>
          </el-table-column>
          <el-table-column prop="insuranceType" key="2" label="险种名称" min-width="80" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="minBase" key="2.1" label="最低基数" min-width="80" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="maxBase" key="3" label="最高基数" min-width="80" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="companyRatio" key="4" label="企业比例" min-width="80" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{(row.companyRatio * 100).toFixed(3) + '%'}}</template>
          </el-table-column>
          <el-table-column prop="companyMinAmount" key="5" label="企业最低缴纳金额" min-width="126" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="companyMaxAmount" key="6" label="企业最高缴纳金额" min-width="126" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="personalRatio" key="7" label="个人比例" min-width="80" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{(row.personalRatio * 100).toFixed(3) + '%'}}</template>
          </el-table-column>
          <el-table-column prop="personalMinAmount" key="8" label="个人最低缴纳金额" min-width="126" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="personalMaxAmount" key="9" label="个人最高缴纳金额" min-width="126" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="minTotal" key="10" label="最低合计" min-width="80" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="maxTotal" key="11" label="最高合计" min-width="80" :show-overflow-tooltip="true" align="center" :formatter="formatAmount">
          </el-table-column>
          <el-table-column prop="companyRepayment" key="12" label="企业补缴" min-width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="companyRepaymentDeadline" key="13" label="企业补缴期限" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="companyLateFee" key="14" label="企业补缴滞纳金" min-width="115" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="personalRepayment" key="15" label="个人补缴" min-width="80" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="personalRepaymentDeadline" key="16" label="个人补缴期限" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="personalLateFee" key="17" label="个人补缴滞纳金" min-width="115" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="notes" key="18" label="备注" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="140" fixed="right" v-if="handleType == 'edit' || handleType == 'add'">
            <template slot-scope={row,$index}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="edit(row,$index)">编辑</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="del($index)" style="margin-left:10px;">
                  <el-button type="text" v-preventReClick slot="reference">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="btn_box">
          <el-button type="success" @click="submit()" :loading="isBtnLoading" v-if="handleType == 'edit' || handleType == 'add'">保存</el-button>
          <el-button @click="backHandle">取消</el-button>
        </div>
      </div>
    </div>

    <el-dialog title="添加险种" :visible.sync="showAddItem" width="950px">
      <el-form :model="itemForm" :inline="true" :rules="rules" ref="itemForm" label-width="120px" size="small">
        <el-form-item label="险种名称:" prop="insuranceType">
          <el-select v-model="itemForm.insuranceType" placeholder="" clearable size="small" style="width: 300px;" filterable>
            <template v-if="this.activeName == '社保'">
              <el-option value="养老保险"></el-option>
              <el-option value="医疗保险"></el-option>
              <el-option value="工伤保险"></el-option>
              <el-option value="失业保险"></el-option>
              <el-option value="生育保险"></el-option>
              <el-option value="大病保险"></el-option>
              <el-option value="长护保险"></el-option>
              <el-option value="补充工伤保险"></el-option>
            </template>
            <el-option value="公积金" v-if="this.activeName == '公积金'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="基数范围:">
          <el-input v-model="itemForm.minBase" type="number" size="small" style="width:120px"></el-input>
          <span style="margin: 0 5px;"> ~ </span>
          <el-input v-model="itemForm.maxBase" size="small" style="width:120px"></el-input>
          <span style="margin-left: 5px;">元</span>
        </el-form-item>
        <el-form-item label="企业比例:">
          <el-input v-model="itemForm.companyRatio" type="number" size="small" style="width:300px"></el-input>
          <div class="tips">注：比例假如为16%请输入0.16</div>
        </el-form-item>
        <el-form-item label="缴费金额上下限:">
          <el-input v-model="itemForm.companyMinAmount" type="number" size="small" style="width:120px"></el-input>
          <span style="margin: 0 5px;"> ~ </span>
          <el-input v-model="itemForm.companyMaxAmount" size="small" style="width:120px"></el-input>
          <span style="margin-left: 5px;">元</span>
          <div class="tips">注：无上限请输入 ‘无上限’</div>
        </el-form-item>
        <el-form-item label="个人比例:">
          <el-input v-model="itemForm.personalRatio" type="number" size="small" style="width:300px"></el-input>
          <div class="tips">注：比例假如为16%请输入0.16</div>
        </el-form-item>
        <el-form-item label="缴费金额上下限:">
          <el-input v-model="itemForm.personalMinAmount" type="number" size="small" style="width:120px"></el-input>
          <span style="margin: 0 5px;"> ~ </span>
          <el-input v-model="itemForm.personalMaxAmount" size="small" style="width:120px"></el-input>
          <span style="margin-left: 5px;">元</span>
          <div class="tips">注：无上限请输入 ‘无上限’</div>
        </el-form-item>
        <el-form-item label="最低合计:">
          <el-input v-model="itemForm.minTotal" size="small" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="最高合计:">
          <el-input v-model="itemForm.maxTotal" size="small" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="企业补缴:">
          <el-select v-model="itemForm.companyRepayment" placeholder="" clearable size="small" style="width: 300px;" filterable>
            <el-option value="允许"></el-option>
            <el-option value="不允许"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="企业补缴期限:">
          <div style="width: 300px;">
            <el-input v-model="qyxz" type="number" size="small" style="width:100px"></el-input>
            <el-select v-model="qyUnit" placeholder="" size="small" style="width: 60px;margin-left: 5px;">
              <el-option value="日"></el-option>
              <el-option value="月"></el-option>
              <el-option value="年"></el-option>
            </el-select>
            <span style="margin-left: 5px;">内</span>
            <el-checkbox v-model="qywxz" style="margin-left: 10px;">无限期限制</el-checkbox>
          </div>
        </el-form-item> -->
        <el-form-item label="企业补缴滞纳金:">
          <el-select v-model="itemForm.companyLateFee" placeholder="" clearable size="small" style="width: 300px;" filterable>
            <el-option value="收取"></el-option>
            <el-option value="不收取"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="个人补缴:">
          <el-select v-model="itemForm.personalRepayment" placeholder="" clearable size="small" style="width: 300px;" filterable>
            <el-option value="允许"></el-option>
            <el-option value="不允许"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="个人补缴期限:">
          <div style="width: 300px;">
            <el-input v-model="grxz" type="number" size="small" style="width:100px"></el-input>
            <el-select v-model="grUnit" placeholder="" size="small" style="width: 60px;margin-left: 5px;">
              <el-option value="日"></el-option>
              <el-option value="月"></el-option>
              <el-option value="年"></el-option>
            </el-select>
            <span style="margin-left: 5px;">内</span>
            <el-checkbox v-model="grwxz" style="margin-left: 10px;">无限期限制</el-checkbox>
          </div>
        </el-form-item> -->
        <el-form-item label="个人补缴滞纳金:">
          <el-select v-model="itemForm.personalLateFee" placeholder="" clearable size="small" style="width: 300px;" filterable>
            <el-option value="收取"></el-option>
            <el-option value="不收取"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="itemForm.notes" size="small" style="width:300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddItem = false" size="small">取消</el-button>
        <el-button type="primary" size="small" :disabled="isSubmit" @click="confirmAddItem">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        id: '',
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        showAddItem: false,
        isBtnLoading: false,
        fileList: [],
        accountList: [],
        activeName: '社保',
        addForm: {
          id: '',
          createUserId: Cookies.get("userid-b"),
          updataUserId: Cookies.get("userid-b"),
          referenceCard: '', //账户
          supplier: '',
          area: '',
          adjustmentMonth: '', //年度基数调整月
          memberStartMonth: '', //增员截止日期
          memberEndMonth: '', //减员截止日期
          startMonthdDiff: '', //增员月差
          endMonthdDiff: '', //减员月差
          typeOfPayment: '', //补缴月类型
          effectiveTime: '', //生效时间
          notes: '', //备注
          detailDtos: [],
          socialSettingsId: '',
          insuranceType: '',
          accountType: ''
        },
        itemForm: {
          id: '',
          createUserId: Cookies.get("userid-b"),
          updataUserId: Cookies.get("userid-b"),
          policyId: '',
          insuranceType: '', //险种名称
          minBase: 0, //最低基数
          maxBase: 0, //最高基数
          companyRatio: 0, //企业比例
          companyMinAmount: 0, //企业最低缴纳金额
          companyMaxAmount: 0, //企业最高缴纳金额
          personalRatio: 0, //个人比例
          personalMinAmount: 0, //个人最低缴纳金额
          personalMaxAmount: 0, //个人最高缴纳金额
          minTotal: null, //最低合计
          maxTotal: null, //最高合计
          companyRepayment: '', //企业补缴
          companyRepaymentDeadline: '', //企业补缴期限
          companyLateFee: '', //企业补缴滞纳金
          personalRepayment: '', //个人补缴
          personalRepaymentDeadline: '', //个人补缴期限
          personalLateFee: '', //个人补缴滞纳金
          notes: '', //备注
          fundAdjustmentMonth: '', //公积金年度基数调整月
          fundMemberStartMonth: '', //公积金增员截止日期
          fundMemberEndMonth: '', //公积金减员截止日期
          fundStartMonthdDiff: '', //公积金增员月差
          fundEndMonthdDiff: '', //公积金减员月差
          fundTypeOfPayment: '', //公积金补缴月类型
          fundEffectiveTime: '', //公积金生效时间
          fundNotes: '', //
        },
        qyxz: '', //企业补缴期限
        qyUnit: '日',
        qywxz: false,
        grxz: '',
        grUnit: '日',
        grwxz: false,
        type: '',
        index: 0,
        isSubmit: false,
        insuranceType: '',
        handleType: 'add',
        isExping2: false,
        rules: {
          socialSettingsId: {
            required: true,
            message: '请选择参保账户',
            trigger: 'change'
          },
          effectiveTime: {
            required: true,
            message: '请选择生效时间',
            trigger: 'change'
          },
          insuranceType: {
            required: true,
            message: '请选择险种名称',
            trigger: 'change'
          },
        }
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.itemForm.id = this.$route.query.id;
        this.id = this.$route.query.id;
        // this.insuranceType = this.$route.query.insuranceType;
        this.handleType = this.$route.query.type;
        this.getDtl();
      }
      this.getAccountList();
    },
    methods: {
      checkPermission,
      //获取账户列表
      getAccountList() {
        let d = {
          PageModel: {
            Rows: 10000,
            Page: 1,
            OrderInput: []
          },
        }
        xz.SocialFun(d, 'GetSocialSettingsPageList', 'post').then(res => {
          if (res.status == 'ok') {
            this.accountList = res.data.data;;
          } else {
            this.accountList = [];
          }
        })
      },
      //获取详情
      getDtl() {
        this.loading = true;
        let d = {
          id: this.id,
          insuranceType: this.activeName,
        }
        xz.SocialFun(d, 'GetPolicyInfo', 'post').then(res => {
          if (res.status == 'ok') {
            if (res.data.detailDtos == null && res.data.detailDtos == undefined) {
              this.addForm.detailDtos = [];
            } else {
              this.addForm = res.data;
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error('获取详情失败');
          }
        })
      },
      changeAcconut(val) {
        let item = this.accountList.find(e => e.id == val);
        this.addForm.referenceCard = item.accountFullName;
        this.addForm.supplier = item.supplierName;
        this.addForm.area = item.serveProvince + '-' + item.serveCity + '-' + item.serveArea;
        this.addForm.accountType = item.accountType;
        this.addForm.accountType = item.accountType;
      },
      addItem() {
        this.type = 'add';
        this.itemForm = this.$options.data.call(this).itemForm;
        this.showAddItem = true;
      },
      confirmAddItem() {
        //   // if (this.qywxz) {
        //   //   this.itemForm.companyRepaymentDeadline = '无限期限制';
        //   // } else {
        //   //   this.itemForm.companyRepaymentDeadline = this.qyxz + this.qyUnit;
        //   // }
        //   // if (this.grwxz) {
        //   //   this.itemForm.personalRepaymentDeadline = '无限期限制';
        //   // } else {
        //   //   this.itemForm.personalRepaymentDeadline = this.grxz + this.grUnit;
        //   // }
        this.$refs.itemForm.validate((valid) => {
          if (valid) {
            // this.itemForm.minTotal = this.itemForm.companyMinAmount + this.itemForm.personalMinAmount;
            // this.itemForm.maxTotal = this.itemForm.companyMaxAmount + this.itemForm.personalMaxAmount;
            if (this.type == 'add') {
              this.addForm.detailDtos.push(this.itemForm);
            } else {
              this.$set(this.addForm.detailDtos, this.index, this.itemForm);
            }
            this.showAddItem = false;
          }
        });
      },
      edit(row, index) {
        this.type = 'edit';
        this.index = index;
        // 假设 row 是你要编辑的行数据
        this.itemForm = {
          ...row
        };
        // 处理 companyRepaymentDeadline
        if (this.itemForm.companyRepaymentDeadline === '无限期限制') {
          this.qyxz = '';
          this.qyUnit = '日'; // 或者你可以设置为其他默认单位
          this.qywxz = true;
        } else {
          // 使用正则表达式提取数字和单位
          const match = this.itemForm.companyRepaymentDeadline.match(/^(\d+)(日|月|年)$/);
          if (match) {
            this.qyxz = parseInt(match[1], 10);
            this.qyUnit = match[2];
            this.qywxz = false;
          } else {
            // 处理格式不正确的情况
            console.error('companyRepaymentDeadline 格式不正确:', this.itemForm.companyRepaymentDeadline);
          }
        }

        // 处理 personalRepaymentDeadline 同理
        if (this.itemForm.personalRepaymentDeadline === '无限期限制') {
          this.grxz = '';
          this.grUnit = '日'; // 或者你可以设置为其他默认单位
          this.grwxz = true;
        } else {
          const match = this.itemForm.personalRepaymentDeadline.match(/^(\d+)(日|月|年)$/);
          if (match) {
            this.grxz = parseInt(match[1], 10);
            this.grUnit = match[2];
            this.grwxz = false;
          } else {
            console.error('personalRepaymentDeadline 格式不正确:', this.itemForm.personalRepaymentDeadline);
          }
        }

        this.showAddItem = true;
      },
      del(index) {
        this.addForm.detailDtos.splice(index, 1)
      },
      submit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.addForm.type = this.activeName == '社保' ? 10 : 20;
            this.isBtnLoading = true;
            xz.SocialFun(this.addForm, 'CreateOrEditSociaInsurancePolicy', 'post').then(res => {
              if (res.status == 'ok') {
                this.isBtnLoading = false;
                this.id = res.data;
                this.addForm.id = res.data;
                this.$message.success('保存成功');
                this.isSubmit = true;
                // setTimeout(() => {
                //   this.backHandle()
                // }, 3000);
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      //金额格式化
      formatAmount(row, column, cellValue) {
        return cellValue ? parseFloat(cellValue).toFixed(2) : '0.00';
      },
      backHandle() {
        window.close()
      },
      expDtl() {
        this.isExping2 = true;
        let d = {
          id: this.id,
          "accountType": "",
          "reference_card": "",
          "supplierName": "",
          "accountFunction": "",
          "serveProvince": "",
          "serveCity": "",
          "serveArea": "",
          "username": "",
          "filename": "明细导出.xlsx"
        }
        xz.SocialExpFun(d, 'ExportSociaInsurancePolicyDetail/download').then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = `明细导出.xlsx`;
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping2 = false;
            } catch (e) {
              this.isExping2 = false;
              this.$message.error('导出异常')
            }
          } else {
            this.$message.error('导出失败');
            this.getList();
            this.isExping = false;
          }
        })
      },
      changeTab() {
        this.getDtl();
        this.isSubmit = false;
      },
      getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];

        columns.forEach((column, index) => {
          if (index === 0) {
            // 第一列显示"合计"文本
            sums[index] = '合计';
            return;
          }

          const values = data.map(item => Number(item[column.property]));

          // 需要计算总和的字段
          const sumFields = [
            'companyMinAmount', 'companyMaxAmount',
            'personalMinAmount', 'personalMaxAmount', 'minTotal', 'maxTotal'
          ];

          if (sumFields.includes(column.property)) {
            // 只对数字字段求和
            if (!values.every(value => isNaN(value))) {
              const sum = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + value;
                } else {
                  return prev;
                }
              }, 0);

              // 使用 formatAmount 方法格式化数值
              sums[index] = this.formatAmount(null, null, sum.toFixed(2));
            } else {
              sums[index] = 'N/A';
            }
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .r_edit_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color: #000;
    /* border-bottom: 1px solid #DCDFE6; */
  }

  .line_box {
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
  }

  .btn_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .tips {
    color: red;
  }
</style>
<style>
  .page_socialInsurance .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_socialInsurance .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_socialInsurance .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_socialInsurance .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_socialInsurance .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_socialInsurance .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>